const config = {
    "auth": {
      "aws_cognito_region": "us-west-2",
      "aws_user_pools_id": "us-west-2_FLZEkI758",
      "aws_user_pools_web_client_id": "662sskih9j5qhn6ih4bdmr8k4i",
      "aws_cognito_login_mechanisms": [
        "EMAIL"
      ],
      "aws_cognito_signup_attributes": [
        "EMAIL"
      ],
      "aws_cognito_username_attributes": [
        "EMAIL"
      ],
      "aws_cognito_mfa_configuration": "ON",
      "aws_cognito_mfa_types": [
        "SMS"
      ],
      "aws_mandatory_sign_in": "enable",
    },
    "env": "prod",
    "api_url": "https://4awnp67sf4.execute-api.us-west-2.amazonaws.com/prod"
}

export default config;
